<script setup lang="ts">
import { Dialog } from "../../../../base-components/Headless";
import Button from "../../../../base-components/Button";
import { ref } from "vue";
import { getFirestore } from "firebase/firestore";
import { userUserStore } from "../../../../stores/user";
import LoadingIcon from "../../../../base-components/LoadingIcon";
import Lucide from "../../../../base-components/Lucide";

import { useUsuariosInvitacionesStore } from "../../../../services/usuariosInvitaciones";
import { UsuarioSistemaInvitacion } from "@fixeduy/restaurantestypes";

interface Props {
  usuario: UsuarioSistemaInvitacion;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: "cerrarInvitacion"): void;
}>();
const sendButtonRef = ref(null);

const db = getFirestore();
const userStore = userUserStore();
const cargando = ref(false);
const usuariosInvitacionesStore = useUsuariosInvitacionesStore();

const handleCancelarInvitacion = async () => {
  cargando.value = true;
  await usuariosInvitacionesStore.cancelar(props.usuario.mail);
  cargando.value = false;
  emit("cerrarInvitacion");
};
</script>

<template>
  <Dialog
    :open="true"
    @close="
      () => {
        emit('cerrarInvitacion');
      }
    "
    :initialFocus="sendButtonRef"
  >
    <Dialog.Panel>
      <Dialog.Description class="">
        <div class="p-5 text-center">
          <Lucide icon="Trash2" class="w-16 h-16 mx-auto mt-3 text-danger" />
          <div class="mt-5 text-3xl">Cancelar invitación</div>
          <div class="mt-5 text-slate-900">
            ¿Seguro que quieres cancelar la invitación a
            {{ usuario.nombre }} - <strong>{{ usuario.mail }}</strong
            >?
          </div>
        </div>
      </Dialog.Description>
      <Dialog.Footer class="mt-6 text-right">
        <div v-if="cargando">
          <div class="flex justify-center my-2">
            <LoadingIcon icon="oval" class="w-8 h-8" />
          </div>
        </div>
        <div v-else class="flex">
          <div class="flex-1 text-left">
            <Button
              variant="secondary"
              class="mb-2 mr-3"
              @click="
                () => {
                  emit('cerrarInvitacion');
                }
              "
            >
              Cancelar</Button
            >
          </div>

          <div class="flex-1">
            <Button
              variant="danger"
              class="mb-2 mr-1"
              @click="handleCancelarInvitacion"
            >
              Confirmar
            </Button>
          </div>
        </div>
      </Dialog.Footer>
    </Dialog.Panel>
  </Dialog>
</template>
